// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBarcodeOutlinedSvg from "@fishx/icons-svg/es/asn/PBarcodeOutlined";
import FishxIcon from '../components/FishxIcon';

var PBarcodeOutlined = function PBarcodeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBarcodeOutlinedSvg
  }));
};

PBarcodeOutlined.displayName = 'PBarcodeOutlined';
export default React.forwardRef(PBarcodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBarcodeOutlined.js
// module id = 3238
// module chunks = 0